/* eslint-disable no-new */
import Vue from 'vue'
import App from './App.vue'
import i18n from './vue/i18n/index'
import router from './vue/router/index'
import store from './vue/store/index'
import './vue/resource/index'
import './vue/components'
import './vue/filters'
import './vue/mixins'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Slick from 'vue-slick';
import $ from 'jquery'
// import 'node_modules/slick-carousel/slick/slick.css';

Vue.use(Vuetify)
Vue.use(Slick)

Vue.http.interceptor.before = (request, next) => {
  console.log(request);
  router.app.updateLoader(true)
  next((response) => {
    router.app.updateLoader(false)
    console.log(response)
  })
}

new Vue({
  el: '#app',
  router: router,
  render: h => h(App),
  i18n: i18n,
  store: store
})



// WEBPACK FOOTER //
// ./src/main.js